import {Charts} from './Charts';
import IDCONSELHOChartsDataProvider from './contexts/IDCONSELHOChartsDataContext'

const IDCONSELHO = () => {
    return (
        <IDCONSELHOChartsDataProvider>
            <Charts />
        </IDCONSELHOChartsDataProvider>
    );
};

export default IDCONSELHO;